<mat-card>

  <mat-card-title><h1><span class="year">{{reportCycleDraft?.year}} </span><span> Report Cycle</span></h1>
  </mat-card-title>

  <mat-card-content>

    <app-kf-next-report-step-bar
      [currentStep]="currentStep"
      [step2Completed] = "step2Completed"
      (loadStep)="loadStep($event)">
    </app-kf-next-report-step-bar>

    <div class="wizard-content">

      <div *ngIf="currentStep == 1">

        <h2>{{"kf-reporting.wizard.header" | translate}}</h2>

        <form *ngIf="yearForm" [formGroup]="yearForm" (ngSubmit)="onYearFormSubmit()">
          <p>{{"kf-reporting.wizard.text1" | translate}}</p>
          <p>{{"kf-reporting.wizard.text2" | translate}}</p>
          <mat-form-field appearance="outline" color="primary">
            <mat-select formControlName="year">
              <mat-option [value]="item" *ngFor="let item of years"> {{item}} </mat-option>
            </mat-select>
          </mat-form-field>
          <p><strong>{{"kf-reporting.wizard.remark" | translate}}</strong></p>
          <small>
            Purpose
            <p>{{"kf-reporting.wizard.purpose" | translate}}</p>
          </small>

          <div class="align-right">
            <button mat-raised-button color="primary">
              <span>Start</span>
              <mat-icon class="material-icons-outlined">play_arrow</mat-icon>
            </button>
          </div>

        </form>

      </div>

      <div *ngIf="currentStep == 2">
        <h2>{{"kf-reporting.wizard.groups.header" | translate}}</h2>
        In this stage 3 steps need to be completed to define the 3 Reporting groups for this Report Cycle:
        <app-kf-next-report-classifiers-wizard
          [reportCycle]="reportCycleDraft"
          [wizardStep]="wizardStep"
          [UNUKeys]="unuKeys"
          [previousUnuKeySets]="previousUNUKeySets"
          [categories]="categories"
          [collectionStreams]="collectionStreams"
          [previousCollectionStreamsSets]="previousCollectionStreams"
          [previousCategoriesSets]="previousCategoriesSets"
          (loadUNUKeysPage)="loadUNUKeys($event)"
          (loadPreviousUNUKeys)="loadPreviousUNUKeySets()"
          (saveUNUKeyForm)="saveUNUKeyForm($event)"
          (loadCategoriesPage)="loadCategories($event)"
          (loadPreviousCategories)="loadPreviousCategoriesSets()"
          (saveCategoriesForm)="saveCategoriesForm($event)"
          (loadCollectionStreamsPage)="loadCollectionStreams($event)"
          (loadPreviousCollectionStreams)="loadPreviousCollectionStreams()"
          (saveCollectionStreamsForm)="saveCollectionStreamsForm($event)"
          (loadWizardStep)="loadStep($event); step2Completed = true"
          (loadWizardStep1)="loadStep($event)"
          (changeWizardStep)="changeWizardStep($event)"
        ></app-kf-next-report-classifiers-wizard>

      </div>

      <div *ngIf="currentStep === 3">
        <div class="summary-header">
          <div class="summary-button-container">
            <button mat-mini-fab color="primary" (click)="goToStep(1)"> 1</button>
          </div>
          <div class="summary-text-container">
            <h2>Report Cycle {{reportCycleDraft.year}}</h2>
          </div>
        </div>

        <div>
          <div class="summary-block">
            <p>The new Report Cycle is ready to be launched. Review your choices and click Launch when ready</p>
            <h3>Reporting groups</h3>

            <div>
              <div class="summary-container">
                <div class="summary-button-container">
                  <button mat-mini-fab color="primary" (click)="goToStep(2)"> 2.1</button>
                </div>
                <div class="summary-text-container">
                  <span>{{reportCycleDraft.unuKeySetName}}</span>
                </div>
              </div>
              <div class="summary-container">
                <div class="summary-button-container">
                  <button mat-mini-fab color="primary" (click)="goToStep(3)"> 2.2</button>
                </div>
                <div class="summary-text-container">
                  <span>{{reportCycleDraft.kfCategorySetName}}</span>
                </div>
              </div>
              <div class="summary-container">
                <div class="summary-button-container">
                  <button mat-mini-fab color="primary" (click)="goToStep(4)"> 2.3</button>
                </div>
                <div class="summary-text-container">
                  <span>{{reportCycleDraft.collectionStreamName}}</span>
                </div>
              </div>
              <div class="align-right">
                <button mat-raised-button color="primary" (click)="launchReport()">
                  <span>Launch</span>
                  <mat-icon class="material-icons-outlined">launch</mat-icon>
                </button>
              </div>
            </div>

          </div>
        </div>


      </div>

    </div>


  </mat-card-content>
</mat-card>
